import { render, staticRenderFns } from "./tabsList.vue?vue&type=template&id=0e83cede&scoped=true&"
import script from "./tabsList.vue?vue&type=script&lang=js&"
export * from "./tabsList.vue?vue&type=script&lang=js&"
import style0 from "./tabsList.vue?vue&type=style&index=0&id=0e83cede&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83cede",
  null
  
)

export default component.exports